<div class="singupcentral fadeIn">
  <div class="contentSignUp">
    <img id="LogoClient" class="float-right LogoClient m-4" [src]="logoUrl" />
    <!-- <i>{{ 'k002463' | translate }}</i> -->
    <!-- Token: Invest better. Save smart. Your savings safe. -->
    <router-outlet></router-outlet>
  </div>
</div>
<tech-loading-screen></tech-loading-screen>
